import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { OpenMetadataTag } from '@/shared/api/openmetadata/types';

export type Database = {
  id: string;
  name: string;
  displayName?: string;
  fullyQualifiedName: string;
  description?: string;
  deleted?: boolean;
  owners?: Array<{
    id: string;
    name: string;
    displayName?: string;
    type: string;
  }>;
  tags?: OpenMetadataTag[];
};

export type DatabasesResponse = {
  data: Database[];
  paging?: {
    total: number;
    after?: string;
    before?: string;
  };
};

export type FetchDatabasesOptions = {
  includeDeleted?: boolean;
};

export const fetchServiceDatabases = async (
  serviceName: string,
  options: FetchDatabasesOptions = {}
): Promise<DatabasesResponse> => {
  const { includeDeleted = false } = options;

  const response = await openMetadataApiClient.get<DatabasesResponse>('/databases', {
    params: {
      service: serviceName,
      fields: 'owners,tags',
      include: includeDeleted ? 'deleted' : 'non-deleted',
      limit: 1000,
    },
  });

  return response.data;
};
